import React, { useState } from 'react'
import styles from './knows.module.css'

const Yourself = () => {
  const [hide, setHide] = useState(styles.hide);
  const [arrowDirection, setArrowDirection] = useState(styles.right);
  const handleClick = event => {
    if(hide == ""){
      setHide(styles.hide);
    } else {
      setHide("");
    }
    if(arrowDirection == styles.right){
      setArrowDirection(styles.down);
    } else {
      setArrowDirection(styles.right);
    }
  };

  return(
    <div className={styles.yourself}>
      <div className={[styles.title, styles.hand].join(' ')} onClick={handleClick}>KNOW Yourself <i className={[styles.arrow, arrowDirection].join(' ')}></i> </div>
      <div className={[styles.body, hide].join(' ')}>
        <ul className={styles.listTitle}>Know your body
          <li className={styles.listItem}>Smile (with exceptions)</li>
          <li className={styles.listItem}>Hands and Arms</li>
          <li className={styles.listItem}>Body - swaying</li>
          <li className={styles.listItem}>Legs and Feet - moving</li>
          <li className={styles.listItem}>Head - microphones and movement</li>
        </ul>
        <ul className={styles.listTitle}>Know your voice
          <li className={styles.listItem}>Adjust your volume</li>
          <li className={styles.listItem}>Adjust your tone</li>
          <li className={styles.listItem}>Adjust your speed</li>
          <li className={styles.listItem}>Adjust your pauses (be okay with silence)</li>
        </ul>
        <ul className={styles.listTitle}>Know your temperment
          <li className={styles.listItem}>Have Fun</li>
          <li className={styles.listItem}>Relax</li>
          <li className={styles.listItem}>Be Flexible not Flustered</li>
        </ul>
      </div>
    </div>
  )
}

export default Yourself
